export default "__VITE_ASSET__Bgc3EHZ5__"